/**
 * Axios HTTP library
 */
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * API Token
 */
let apiToken = document.head.querySelector('meta[name="api-token"]');

if (apiToken) {
    window.axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken.content}`;
}


import Vue from 'vue'

window.Vue = Vue;

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
    moment,
})

import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

import LoadingComponent from './lazy/LoadingComponent.vue'
import ErrorComponent from './lazy/ErrorComponent.vue'

Vue.prototype.$GroupControl = () => ({ component: import('./lazy/controls/GroupControl.vue') })
Vue.prototype.$CheckboxControl = () => ({ component: import('./lazy/controls/CheckboxControl.vue') })
Vue.prototype.$InputControl = () => ({
  component: import('./lazy/controls/InputControl.vue'),
  loading: LoadingComponent,
  error: ErrorComponent,
  timeout: 3000
})
Vue.prototype.$RadioControl = () => ({ component: import('./lazy/controls/RadioControl.vue') })
Vue.prototype.$RateControl = () => ({ component: import('./lazy/controls/RateControl.vue') })
Vue.prototype.$SelectControl = () => ({ component: import('./lazy/controls/SelectControl.vue') })
Vue.prototype.$SwitchControl = () => ({ component: import('./lazy/controls/SwitchControl.vue') })
Vue.prototype.$AvatarControl = () => ({ component: import('./lazy/controls/AvatarControl.vue') })

Vue.prototype.$TextareaControl = () => ({
  component: import('./lazy/controls/TextareaControl.vue'),
  loading: LoadingComponent,
  error: ErrorComponent,
  timeout: 3000
})

Vue.component(
  'VuePlyr',
  () => ({
    component: import('./lazy/VuePlyr.vue'),
    loading: LoadingComponent,
    error: ErrorComponent,
    timeout: 3000
  })
)

Vue.component(
  'TestimonialSlider',
  () => ({
    component: import('./lazy/TestimonialSlider.vue'),
    loading: LoadingComponent,
    error: ErrorComponent,
    timeout: 3000
  })
)

Vue.component(
  'AppGallerySlider',
  () => ({
    component: import('./lazy/AppGallerySlider.vue'),
    loading: LoadingComponent,
    error: ErrorComponent,
    timeout: 3000
  })
)



/**
 * i18n
 */
import VueI18n from 'vue-i18n';

//import fr from '../lang/fr.json';
import en from '../lang/en.json';
//import pl from '../lang/pl.json';
const messages = { en };

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: window.BoldCMS.locale,
  messages
});

const files = require.context('./public/components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const shared = require.context('./components/', true, /\.vue$/i)
shared.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], shared(key).default))

import Notify from './elements/notify/'

Vue.use(Notify, {
  showDuration: 10000
})

require('./plugins/ui')
require('./plugins/validate')

Vue.config.productionTip = false
//Vue.prototype.$locomotive = null

import store from './public/store/'

function init() {
    // VUE
    let app = new Vue({
        store,
        i18n,
        el: '#app'
    });

}
init()
